import { ActionReducerMap } from '@ngrx/store';
import { TNavigationState } from './navigation/navigation.models';
import * as fromNavigationReducer from './navigation/navigation.reducer';
import { TMMFactoryState } from './factory/factory.models';
import * as fromFactoryReducer from './factory/factory.reducer';
import { TMachineListState } from './machine-list/machine-list.models';
import * as fromMachineListReducer from './machine-list/machine-list.reducer';
import { TLocationManagementState } from './location-management/location-management.models';
import * as fromLocationManagementReducer from './location-management/location-management.reducer';
import { TEmployeeManagementState } from './employee-management/employee-management.models';
import * as fromEmployeeManagementReducer from './employee-management/employee-management.reducer';
import { TMechanicDashboardState } from './mechanic-dashboard/mechanic-status-dashboard.models';
import * as fromMechanicDashboardReducer from './mechanic-dashboard/mechanic-dashboard.reducer';
import { TBreakdownReasonsState } from './breakdown-reasons/breakdown-reasons.models';
import * as fromBreakdownReasonsReducer from './breakdown-reasons/breakdown-reasons.reducer';
import { TMachineServiceState } from './machine-service/machine-service.models';
import * as fromMachineServiceReducer from './machine-service/machine-service.reducer';
import { TLineSetUpState } from './line-setup/line-setup.models';
import * as fromLineSetupReducer from './line-setup/line-setup.reducer';
import { TTicketManagementState } from './ticket-management/ticket-management.models';
import * as fromTicketManagementReducer from './ticket-management/ticket-management.reducer';
import { TSparePartListState } from './sparepart-list/sparepart-list.models';
import * as fromSparePartListReducer from './sparepart-list/sparepart-list.reducer';
import { TNeedleManagementState } from './needle-management/needle-management.models';
import * as fromNeedleManagementReducer from './needle-management/needle-management.reducer';
import { TConfigSetupState } from './config-setup/config-setup.models';
import * as fromConfigStateReducer from './config-setup/config-setup.reducer';
import { TNptState } from './npt/npt.models';
import * as fromNptReducer from './npt/npt.reducer';
import * as fromAttachmentReducer from './attachment/attachment.reducer';
import { TAttachmentState } from './attachment/attachment.model';
import { TChatbotState } from './chatbot/chatbot.models';
import * as fromChatbotReducer from './chatbot/chatbot.reducer';
import * as fromQcoReducer from './qco/qco.reducer';
import { TQcoState } from './qco/qco.models';
import * as fromShiftManagementReducer from './shift-management/shift-management.reducer';
import { TShiftManagementState } from './shift-management/shift-management.models';

export type TMachineMaintenanceState = {
  navigationInfo: TNavigationState;
  factoryInfo: TMMFactoryState;
  machineListInfo: TMachineListState;
  configSetupInfo: TConfigSetupState;
  locationManagementInfo: TLocationManagementState;
  employeeManagementInfo: TEmployeeManagementState;
  mechanicDashboardInfo: TMechanicDashboardState;
  breakdownReasonsInfo: TBreakdownReasonsState;
  lineSetupInfo: TLineSetUpState;
  ticketManagementInfo: TTicketManagementState;
  machineServiceInfo: TMachineServiceState;
  sparePartServiceInfo: TSparePartListState;
  needleManagementInfo: TNeedleManagementState;
  nptInfo: TNptState;
  attachmentInfo: TAttachmentState;
  chatbotInfo: TChatbotState;
  qcoInfo: TQcoState;
  shiftManagementInfo: TShiftManagementState;
};

// Ngrx is not correctly typed for reducer. Github discussion on this issue
// https://github.com/ngrx/platform/issues/951
export const machineMaintenanceReducer: ActionReducerMap<TMachineMaintenanceState, never> = {
  navigationInfo: fromNavigationReducer.navigationReducer,
  factoryInfo: fromFactoryReducer.factoryReducer,
  machineListInfo: fromMachineListReducer.machineListReducer,
  configSetupInfo: fromConfigStateReducer.configSetupReducer,
  locationManagementInfo: fromLocationManagementReducer.locationManagementReducer,
  employeeManagementInfo: fromEmployeeManagementReducer.employeeManagementReducer,
  mechanicDashboardInfo: fromMechanicDashboardReducer.mechanicDashboardReducer,
  breakdownReasonsInfo: fromBreakdownReasonsReducer.breakdownReasonsReducer,
  lineSetupInfo: fromLineSetupReducer.lineSetupReducer,
  ticketManagementInfo: fromTicketManagementReducer.ticketManagementReducer,
  machineServiceInfo: fromMachineServiceReducer.machineServiceReducer,
  sparePartServiceInfo: fromSparePartListReducer.sparePartListReducer,
  needleManagementInfo: fromNeedleManagementReducer.needleManagementReducer,
  nptInfo: fromNptReducer.nptReducer,
  attachmentInfo: fromAttachmentReducer.attachmentReducer,
  chatbotInfo: fromChatbotReducer.chatbotReducer,
  qcoInfo: fromQcoReducer.qcoReducer,
  shiftManagementInfo: fromShiftManagementReducer.shiftManagementReducer,
};
